.autocomplete {
  width: 100%;
}
